import html from '../legacy/mc.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function MechanicsControl() {
  return <LegacyHtmlPage slug="mc" title="Mechanics & Optimal Control" html={html} />;
}
